import { defineStore } from "pinia";

export const usePopularStore = defineStore("popular", {
    state() {
        return {
            filter: [],
            trips: [],
        };
    },
    actions: {
        setup(trips) {
            this.setAllTripsVisible(trips);
            this.setupFilter(trips);
        },
        setupFilter(trips) {
            let filter = trips.map((trip) => {
                return trip.days.length;
            });

            filter = Array.from(new Set(filter)).sort();

            filter = filter.map((length) => ({
                label: `${length} day${length > 1 ? "s" : ""}`,
                active: false,
                length,
            }));

            filter.unshift({
                label: "all",
                active: true,
                length: null,
            });

            this.filter = filter;
        },
        setActiveFilter(button) {
            this.filter = this.filter.map((item) => {
                item.active = item.length === button.length;
                return item;
            });
            this.setActiveTrips(button.length);
        },
        setAllTripsVisible(trips) {
            this.trips = trips.map((trip) => {
                trip.visible = true;
                return trip;
            });
        },
        setActiveTrips(length) {
            if (length === null) {
                this.setAllTripsVisible(this.trips);
                return;
            }
            this.trips = this.trips.map((trip) => {
                trip.visible = trip.days.length === length;
                return trip
            });
        },
    },
});
